module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/nomina/detalles/nomina-detalles.component.scss
// module id = ./src/app/creditos/nomina/detalles/nomina-detalles.component.scss
// module chunks = main